import { type CustomizationMachineAction } from '../../types';
import { customizationLogger } from './logger';

// ─────────────────────────────────────────────────────────────────────────────

export function createPlaceholderAction(actionName: string): CustomizationMachineAction {
  return () => {
    customizationLogger.info(`\`${actionName}\` action is not provided.`);
  };
}

export function createPlaceholderActionWithParams<ActionParams extends Record<string, unknown>>(
  actionName: string,
): CustomizationMachineAction<ActionParams> {
  return () => {
    customizationLogger.info(`\`${actionName}\` action is not provided.`);
  };
}

export function createPlaceholderGuard(guardName: string) {
  return () => {
    customizationLogger.info(`\`${guardName}\` guard is not provided.`);

    return false;
  };
}
